<template>
  <span class="app-text-help">
    <span class="app-text-help__text">{{ text }}</span>
    <el-tooltip v-if="tip" effect="dark" placement="right">
      <div class="app-text-help__tip" slot="content" v-html="tip"></div>
      <app-svg-icon icon-class="help"></app-svg-icon>
    </el-tooltip>
  </span>
</template>

<script>
export default {
  name: 'AppTextHelp',
  props: {
    text: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.app-text-help {
  &__text {
    vertical-align: middle;
  }

  &__tip {
    max-width: 240px;
    font-family: sans-serif;
    font-size: 12px;
    line-height: 1.5;
  }
}
</style>
